import { addSpacing } from 'utils/utils';

export const initialState = {
    companyID: '',
    companyName: '',
    id: '',
    name: '',
    permissions: [],
    requiredScope: 20,
    requiredScopeName: 'Admin',
    readOnly: false,
    optOut: false,
};

export const CRUD_MODES = ['Create', 'Read', 'Update', 'Delete'];
export const CRUD_FIELDS = CRUD_MODES.map((mode) => mode.toLowerCase());
export const SCOPES = [20, 40, 60, 80];

export const BREADCRUMB_TRAIL = [
    { label: 'Permissions Sets', path: ['/admins', { index: 2 }] },
    { label: 'Permissions Set Edit', path: '' },
];

// Set filter needs its own valueFormatter -- column-level filterParams replaces AGGridMain's default, doesn't merge with it.
export const REQUIRED_SCOPE_FILTER_PARAMS = {
    closeOnApply: false,
    filters: [
        {
            filter: 'agTextColumnFilter',
            filterParams: {
                closeOnApply: false,
                applyMiniFilterWhileTyping: true,
            },
        },
        {
            filter: 'agSetColumnFilter',
            filterParams: {
                closeOnApply: false,
                applyMiniFilterWhileTyping: true,
                suppressMiniFilter: true,
                valueFormatter: (params) => addSpacing(params.value),
            },
        },
    ],
};
